import React, { Component } from 'react';
import { Modal, Container, Row, Col, FormControl, Image, Dropdown, DropdownButton, Form, Button, Pagination, ButtonToolbar, OverlayTrigger, Tooltip } from 'react-bootstrap';
import NavbarComponent from '../Navbar/index';
import RenovateTokenAlert from '../../RenovateToken';
import ReactNotification from 'react-notifications-component';
import { store } from 'react-notifications-component';
import { Spinner } from 'react-activity';

import Backend from '../../Backend';
import { CSVLink } from "react-csv";
import SearchImage from '../../Images/search.svg';
import Connection from '../../Calls';

import ModalAddAddress from './addAddress'
import ModalEditAddress from './updateAddress'


var date = new Date();
// var HeightScreen = window.screen.height;

class TransactionsIndex extends Component {
  constructor(props) {
    super(props)
    this.state = {
      idWallet: '',
      search: '',
      orderBySelect: 'Date newest',
      sendOrderBySelect: 'date_new',
      numeroFilas: 25,
      paginaActual: 1,
      whitelistpagination: [],
      availableCoinsArray:[],
      coin:{
        symbol:''
      },
      status:'',
      search:'',
      paginaActual:1,
      numeroFilas:25,
      selectedAddress:'',
    }
    this.closeModal = this.closeModal.bind(this)
    this.whiteListPagiation = this.whiteListPagiation.bind(this)
  }

  componentWillMount() {
    this.whiteListPagiation();
    this.availableCoins();
  }

  whiteListPagiation() {
    const self = this;
    var fechaInicio = "";
    var fechaFinal = "";
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.GetWhiteList(localStorage.getItem('email'), localStorage.getItem('token'), self.state.coin.symbol, self.state.status, self.state.search, self.state.paginaActual, self.state.numeroFilas,response.payload.r01, response => {
        if (response.status.code === "0") {
            self.setState({
              whitelistpagination: response.payload || [],
              dataLength: Math.ceil(response.payload.total_amount / self.state.numeroFilas),
              showLoad: false
            });
        } else {
          self.setState({
            whitelistpagination: [],
            showLoad: false
          });
          store.addNotification({
            title: "Error!",
            message: response.status.description,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 1800,
              onScreen: true
            }
          });
        }
      });
    });
  }

  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      this.setState({ whitelistpagination: [], paginaActual:1, showLoad:true},()=>this.whiteListPagiation())
    }
  }

  changePage(value) {
    this.setState({
      paginaActual: value,
    },()=>this.whiteListPagiation());
  }

  availableCoins(){
    const self = this;
    var idWallet = new window.URL(window.location.href).searchParams.get("id");
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.availableCoins(response => {
        this.setState({
          availableCoinsArray: response.payload
        })
      })


      Backend.GetUserInfo2(localStorage.getItem('email'), localStorage.getItem('token'), response.payload.r01, response => {
        if(response.status.code == 0){
          this.setState({
            wlStatus:(response.payload.whitelist_active == 'enabled')?'enabled':'disabled',
          })
        }
      });


    });
  }
  renderCoins(){
    return this.state.availableCoinsArray.map((item,i)=>{
      return(
        <Dropdown.Item onClick={() => { this.setState({ coin: item },()=>this.whiteListPagiation()) }} as="button">
          <Image src={require("../../CryptoIcons/" + item.symbol + ".svg")} style={{ width: 15, marginTop: -4, marginRight: 5 }} />
          {item.name}
        </Dropdown.Item>
      )
    })
  }

  renderWhiteList() {
    const self = this;
    var users = [];
    self.state.whitelistpagination.forEach(function (row) {
      users.push(
        <ButtonToolbar onClick={()=>{self.setState({selectedAddress:row, showEdit:true})}} style={{ display: "contents" }}>
          <OverlayTrigger
            key="top"
            placement="top"
            overlay={
              <Tooltip
                id="tooltip-top"
                >
                Address Label: {row.label}
              </Tooltip>
            }
            >
            <tr className="hover-tr-table-wallets-generals" style={{ cursor: "default" }}>
              <td><Image src={require("../../CryptoIcons/" + row.coin + ".svg")} className="icon-crypto-svg" /></td>
              <td className="text-table-container-addres-information">{row.address}</td>
              <td className="text-table-container-addres-information">{row.label}</td>
              <td className={"text-table-container-addres-information " + row.status}>{row.status}</td>
              <td className="text-table-container-addres-information">{row.max_amount} {row.coin.toUpperCase()}</td>
              <td className="text-table-container-addres-information">
                <div className="three-dots-txid">

                </div>
              </td>
            </tr>
          </OverlayTrigger>
        </ButtonToolbar>
      );
    });
    return users;
  }

  closeModal(){
    this.setState({
      showModal:false,
      showEdit:false,
      selectedAddress:''
    })
  }

  render() {
    return (
      <div>
        <NavbarComponent data={this.props} selected="whitelist" logged={true} />
        <RenovateTokenAlert data={this.props} />
        {(this.state.wlStatus ==  'disabled')&&<div className='view-blocker'> <p>{this.props.traductions.whitelist.alert}</p></div>}
        <div className="contenedor-wallets-generals" style={{ paddingLeft: 10, paddingRight: 10 }}>
          <div className="container-transactions" style={{ width: "100%" }}>
            <div className="border-title-separator-container">
              <div className="border-title-separator-container-left">
                <p className="title-container-shadow">{this.props.traductions.whitelist.title}</p>
              </div>
              <div className="border-title-separator-container-right">
                <Button className="wirebit-transfer-generals-button" variant="primary" onClick={() => { this.setState({showModal:true}); }}>{this.props.traductions.whitelist.addAddrss}</Button>
              </div>
            </div>
            <div style={{ marginBottom: 50 }}>
              <Container fluid>
                <Row>
                  <Col md={3} className='virtual_exchange_dropdown'>
                    <Form.Label className="virtual_exchange_information_wallets_text">{this.props.traductions.whitelist.L_Coin}:</Form.Label>
                    <DropdownButton title={(this.state.coin.symbol)?this.state.coin.symbol:this.props.traductions.whitelist.L_SelectCoin}>
                      {this.renderCoins()}
                    </DropdownButton>
                  </Col>

                  <Col md={3} className='virtual_exchange_dropdown'>
                    <Form.Label className="virtual_exchange_information_wallets_text">{this.props.traductions.whitelist.L_Status}:</Form.Label>
                    <DropdownButton title={(this.state.status)?this.state.status:this.props.traductions.whitelist.L_SelectStatus}>
                        <Dropdown.Item onClick={() => { this.setState({ status: 'enabled' },()=>this.whiteListPagiation()) }} as="button">
                          {this.props.traductions.whitelist.L_StatusE}
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => { this.setState({ status: 'disabled' },()=>this.whiteListPagiation()) }} as="button">
                          {this.props.traductions.whitelist.L_StatusD}
                        </Dropdown.Item>
                    </DropdownButton>
                  </Col>
                  <Col md={5} xs={11} className='virtual_exchange_dropdown'>
                    <Form.Label className="virtual_exchange_information_wallets_text">{this.props.traductions.whitelist.L_Search}:</Form.Label>
                    <Form.Control style={{ height: 40 }} className="input-signup" type="text" placeholder={this.props.traductions.whitelist.L_Search} value={this.state.search} onKeyPress={this.handleKeyPress} onChange={(search) => { this.setState({ search: search.target.value }) }} />
                  </Col>

                  <Col md={1} xs={1}>
                    <div style={{ paddingTop: 24, textAlign:'center'}}>
                      <Button className="signup-button" style={{ height: 40, width:40, padding: 0 }} onClick={() => { this.whiteListPagiation() }}>
                        <Image src={SearchImage} style={{ width: 20, marginTop:-4 }} />
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
            <div className="scroll-table-wallets-generals transactions-table-height">
              <table className="table-container-wallets-generals">
                <thead>
                  <tr>
                    <th className="header-table-wallets-generals fixxxed"></th>
                    <th className="header-table-wallets-generals fixxxed">{this.props.traductions.whitelist.T_H_WA}</th>
                    <th className="header-table-wallets-generals fixxxed">{this.props.traductions.whitelist.T_H_label}</th>
                    <th className="header-table-wallets-generals fixxxed">{this.props.traductions.whitelist.T_H_status}</th>
                    <th className="header-table-wallets-generals fixxxed">{this.props.traductions.whitelist.T_H_maxAmount}</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    (this.state.showLoad)
                    ?
                    <tr>
                      <td colspan='9' style={{textAlign:'center',height:374}}>
                        <Spinner animated color='#053164' size={90}/>
                      </td>
                    </tr>
                    :this.renderWhiteList()
                  }
                </tbody>
              </table>
            </div>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: 40 }}>
              <DropdownButton id="dropdown-item-button-step1" title={this.state.numeroFilas}>
                <Dropdown.Item onClick={() => { this.setState({ numeroFilas: 25 }, ()=>this.whiteListPagiation()) }} as="button">25</Dropdown.Item>
                <Dropdown.Item onClick={() => { this.setState({ numeroFilas: 50 }, ()=>this.whiteListPagiation()) }} as="button">50</Dropdown.Item>
                <Dropdown.Item onClick={() => { this.setState({ numeroFilas: 100 }, ()=>this.whiteListPagiation()) }} as="button">100</Dropdown.Item>
              </DropdownButton>

              <Pagination>
                <Pagination.First disabled={this.state.paginaActual === 1 || this.state.showLoad} onClick={() => {
                    if (this.state.paginaActual !== 0) {
                      this.changePage(1);
                    }
                  }} />
                <Pagination.Prev disabled={this.state.paginaActual === 1 || this.state.showLoad} onClick={() => {
                      if (this.state.paginaActual !== 0) {
                        this.changePage(this.state.paginaActual - 1);
                      }
                    }} />
                    {this.state.paginaActual > 2 &&
                      <Pagination.Item disabled={this.state.showLoad} onClick={() => { this.changePage(this.state.paginaActual - 2) }}>{this.state.paginaActual - 2}</Pagination.Item>
                    }
                    {this.state.paginaActual > 1 &&
                      <Pagination.Item disabled={this.state.showLoad} onClick={() => { this.changePage(this.state.paginaActual - 1) }}>{this.state.paginaActual - 1}</Pagination.Item>
                    }
                    <Pagination.Item active>{this.state.paginaActual}</Pagination.Item>
                    {this.state.paginaActual < this.state.dataLength &&
                      <Pagination.Item disabled={this.state.showLoad} onClick={() => { this.changePage(this.state.paginaActual + 1) }}>{this.state.paginaActual + 1}</Pagination.Item>
                    }
                    {this.state.paginaActual < this.state.dataLength - 1 &&
                      <Pagination.Item disabled={this.state.showLoad} onClick={() => { this.changePage(this.state.paginaActual + 2) }}>{this.state.paginaActual + 2}</Pagination.Item>
                    }
                    <Pagination.Next disabled={this.state.paginaActual >= this.state.dataLength || this.state.showLoad} onClick={() => {
                        if (this.state.paginaActual < this.state.dataLength) {
                          this.changePage(this.state.paginaActual + 1)
                        }
                      }} />
                    <Pagination.Last disabled={this.state.paginaActual >= this.state.dataLength || this.state.showLoad} onClick={() => {
                          if (this.state.paginaActual < this.state.dataLength) {
                            this.changePage(this.state.dataLength)
                          }
                        }} />
                      </Pagination>
                    </div>
                  </div>
                </div>
                <ModalAddAddress whiteListPagiation={this.whiteListPagiation} closeModal={this.closeModal}{...this.state} traductions={this.props.traductions.whitelist} traductionsTwofa={this.props.traductions.General.TwoFa}/>
                {(this.state.selectedAddress)&&
                  <ModalEditAddress whiteListPagiation={this.whiteListPagiation} closeModal={this.closeModal}{...this.state} traductions={this.props.traductions.whitelist} traductionsTwofa={this.props.traductions.General.TwoFa}/>
                }
              </div >
            );
          }
        } export default TransactionsIndex;
